import AppEvent from './AppEvent';

class PostListUpdateEvent extends AppEvent {
  static getName() {
    return 'post-list-update';
  }
}

export default PostListUpdateEvent;
